import { Pipe, PipeTransform, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { StringHelper } from '../helpers/string.helper';

@Pipe({ name: 'noHtml' })
export class SanitizeHTMLPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(value: string): string {
    return StringHelper.processValueToEntity(this.sanitizer.sanitize(SecurityContext.HTML, value) ?? '');
  }
}
